import { Outlet } from "@tanstack/react-router";
import React from "react";

import { HeaderBar } from "./header";

export const PageLayout: React.FC = () => {
  return (
    <>
      <header>
        <HeaderBar />
      </header>
      <main>
        <Outlet />
      </main>
    </>
  );
};
